(() => {
  const menuSelector = '.za-menu';
  const root = document.documentElement;
  const mobileQuery = window.matchMedia('(max-width: 760px)');
  let lockedScrollY = 0;
  let rafId = 0;

  const getMenu = () => document.querySelector(menuSelector);
  const getHeader = () => document.querySelector('.za-header');

  const setMenuOffset = () => {
    const header = getHeader();
    if (!header) return;
    const headerHeight = Math.ceil(header.getBoundingClientRect().height);
    root.style.setProperty('--za-mobile-menu-top', `${headerHeight}px`);
  };

  const lockPage = () => {
    setMenuOffset();
    if (root.classList.contains('za-menu-is-open')) return;
    lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    root.style.setProperty('--za-menu-scroll-lock-top', `-${lockedScrollY}px`);
    root.classList.add('za-menu-is-open');
    document.body.classList.add('za-menu-is-open');
  };

  const unlockPage = () => {
    if (!root.classList.contains('za-menu-is-open')) return;
    root.classList.remove('za-menu-is-open');
    document.body.classList.remove('za-menu-is-open');
    root.style.removeProperty('--za-menu-scroll-lock-top');
    window.requestAnimationFrame(() => window.scrollTo(0, lockedScrollY));
  };

  const syncMenuState = () => {
    const menu = getMenu();
    const shouldLock = Boolean(menu && menu.open && mobileQuery.matches);
    if (shouldLock) {
      lockPage();
    } else {
      unlockPage();
    }
  };

  const scheduleOffset = () => {
    if (!root.classList.contains('za-menu-is-open')) return;
    window.cancelAnimationFrame(rafId);
    rafId = window.requestAnimationFrame(setMenuOffset);
  };

  document.addEventListener('toggle', (event) => {
    if (event.target && event.target.matches && event.target.matches(menuSelector)) {
      syncMenuState();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.za-menu__panel a');
    if (!link) return;
    const menu = link.closest(menuSelector);
    if (menu) menu.open = false;
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = getMenu();
    if (!menu || !menu.open) return;
    menu.open = false;
    menu.querySelector('summary')?.focus({ preventScroll: true });
  });

  const handleViewportChange = () => {
    syncMenuState();
    scheduleOffset();
  };

  window.addEventListener('resize', handleViewportChange);
  window.addEventListener('orientationchange', handleViewportChange);
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', syncMenuState);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(syncMenuState);
  }
  window.addEventListener('pageshow', syncMenuState);
  document.addEventListener('DOMContentLoaded', syncMenuState, { once: true });
})();
